
import { ref, onMounted, computed } from "vue";
import { usePlugin } from "@/plugins";
import { clone } from "ramda";
import { Instructor, UpsertInstructorRequest } from "@/types";
import Fuse from "fuse.js";
import BackButton from "@/components/BackButton.vue";

export default {
  name: "Instructor",
  components: { BackButton },
  setup() {
    const { success, error, axios, setLoading } = usePlugin();

    const instructorTable = ref(null);
    const instructors = ref<Instructor[]>([]);
    const instructor = ref<Instructor>({} as Instructor);
    const showDialog = ref(false);
    const popupDeleteDialog = ref(false);
    const searchString = ref("");
    const submitted = ref(false);
    const existInstructorId = ref(false);
    const duplicateInstructorId = ref(false);

    const filteredInstructor = computed(() => {
      if (!searchString.value) return instructors.value;
      const fuse = new Fuse(instructors.value, {
        keys: ["instructorId", "name"],
      });
      const searchResult = fuse.search(searchString.value);
      return searchResult.map((x) => x.item);
    });

    const loadInstructors = async () => {
      setLoading(true);
      try {
        const result = await axios.post<Instructor[]>(
          "api/v1/services/instructor/get"
        );
        instructors.value = result.data;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onNewInstructor = () => {
      instructor.value = {} as Instructor;
      showDialog.value = true;
      submitted.value = false;
      existInstructorId.value = false;
    };

    const onSaveInstructor = async () => {
      submitted.value = true;

      setLoading(true);
      try {
        const result = await axios.post("api/v1/services/instructor/upsert", {
          instructors: [instructor.value],
        } as UpsertInstructorRequest);
        await loadInstructors();
        success("บันทึกข้อมูลสำเร็จแล้ว");
        showDialog.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    const onHideDialog = () => {
      showDialog.value = false;
      submitted.value = false;
      duplicateInstructorId.value = false;
    };

    const onEditInstructor = (source: Instructor) => {
      instructor.value = clone(source);
      showDialog.value = true;
      existInstructorId.value = true;
    };

    const onDeleteInstructor = (source: Instructor) => {
      instructor.value = clone(source);
      popupDeleteDialog.value = true;
    };

    const handleDeleteInstructor = async () => {
      setLoading(true);
      try {
        const result = await axios.delete("api/v1/services/instructor/delete", {
          data: {
            instructors: [instructor.value],
          } as UpsertInstructorRequest,
        });
        await loadInstructors();
        success("ลบข้อมูลสำเร็จแล้ว");
        popupDeleteDialog.value = false;
      } catch (e) {
        error(e);
      } finally {
        setLoading(false);
      }
    };

    onMounted(async () => {
      await loadInstructors();
    });
    return {
      instructorTable,
      instructor,
      instructors,
      filteredInstructor,
      showDialog,
      submitted,
      existInstructorId,
      duplicateInstructorId,
      popupDeleteDialog,
      searchString,
      onNewInstructor,
      onEditInstructor,
      onDeleteInstructor,
      onSaveInstructor,
      handleDeleteInstructor,
      onHideDialog,
    };
  },
};
